var globalVariables;
(function (globalVariables) {
    globalVariables["NOT_AVAILABLE"] = "\u2014";
    globalVariables["NO_RESULTS_FOUND"] = "No results found";
})(globalVariables || (globalVariables = {}));
export default globalVariables;
